import { subscription } from './account/subscription';
import { enterprise } from './account/enterprise';
import { payments } from './account/payments';
import { accounts } from './data/accounts';
import { admin } from './account/admin';

import { analyses } from './data/analyses';
import { collaborators } from './data/collaborators';
import { dependencies } from './data/dependencies';
import { documents } from './data/documents';
import { entries } from './data/entries';
import { forms } from './data/forms';
import { help } from './data/help';
import { notifications } from './data/notifications';
import { projects } from './data/projects';
import { revisions } from './data/revisions';
import { roles } from './data/roles';
import { snapshots } from './data/snapshots';
import { statuses } from './data/statuses';
import { templates } from './data/templates';
import { variables } from './data/variables';
import { variablesMapping } from './data/variablesMapping';

export const apiFactory = () => ({
	account: {
		admin: () => admin(),
		enterprise: () => enterprise(),
		payments: () => payments(),
		subscription: () => subscription()
	},
	data: {
		accounts: () => accounts(),
		analyses: () => analyses(),
		collaborators: () => collaborators(),
		dependencies: () => dependencies(),
		documents: () => documents(),
		entries: () => entries(),
		forms: () => forms(),
		help: () => help(),
		notifications: () => notifications(),
		projects: () => projects(),
		revisions: () => revisions(),
		roles: () => roles(),
		snapshots: () => snapshots(),
		statuses: () => statuses(),
		templates: () => templates(),
		variables: () => variables(),
		variablesMapping: () => variablesMapping()
	}
});

export type ApiFactory = ReturnType<typeof apiFactory>;
